"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Printer from foundation/Printer
 * @trackcomponent
 */
export const Printer = createSVGIcon(
  <>
    <g
      id="1.0-Modal_Order-Fulfillment-1440"
      transform="translate(-560 -290)"
      fill="currentColor"
      fillRule="nonzero"
    >
      <g id="Modal" transform="translate(470 50)">
        <g id="Bullets" transform="translate(90 187)">
          <g id="2" transform="translate(0 49)">
            <path
              d="M2.65909087,4.34482759 L2.65909087,8.13793103 L0.818181777,8.13793103 C0.371998616,8.13793103 0,8.4515 0,8.82758621 L0,14.6896603 C0,15.0657466 0.371998616,15.3793155 0.818181777,15.3793155 L2.65909087,15.3793155 L2.65909087,18.4827638 C2.65911132,18.6633155 2.85398791,18.8275741 3.06818178,18.8275914 L14.9318181,18.8275914 C15.146012,18.8275741 15.3408886,18.6633155 15.3409091,18.4827638 L15.3409091,15.3793155 L17.1818181,15.3793155 C17.6280013,15.3793155 18,15.0657466 18,14.6896603 L18,8.82758621 C18,8.4515 17.6280013,8.13793103 17.1818181,8.13793103 L15.3409091,8.13793103 L15.3409091,4.34482759 C15.3408886,4.16427586 15.146012,4.00001724 14.9318181,4 L3.06818178,4 C2.84659155,4.00258621 2.6641186,4.1895 2.65909087,4.34482759 Z M3.47727269,4.68965517 L14.5227272,4.68965517 L14.5227272,8.13793103 L3.47727269,8.13793103 L3.47727269,4.68965517 Z M0.818181777,8.82758621 L17.1818181,8.82758621 L17.1818181,14.6896603 L15.340909,14.6896603 L15.340909,12.9655224 C15.3408886,12.7849707 15.146012,12.6207121 14.9318181,12.6206948 L3.06818178,12.6206948 C2.85398791,12.6207121 2.65911132,12.7849707 2.65909087,12.9655224 L2.65909087,14.6896603 L0.818181777,14.6896603 L0.818181777,8.82758621 Z M12.8863636,9.51724138 C12.5474645,9.51724138 12.2727272,9.74882759 12.2727272,10.0344828 C12.2727272,10.3201379 12.5474645,10.5517241 12.8863636,10.5517241 C13.2252627,10.5517241 13.5,10.3201379 13.5,10.0344828 C13.5,9.74882759 13.2252627,9.51724138 12.8863636,9.51724138 Z M14.9318181,9.51724138 C14.592919,9.51724138 14.3181818,9.74882759 14.3181818,10.0344828 C14.3181818,10.3201379 14.592919,10.5517241 14.9318181,10.5517241 C15.2707172,10.5517241 15.5454545,10.3201379 15.5454545,10.0344828 C15.5454545,9.74882759 15.2707172,9.51724138 14.9318181,9.51724138 Z M3.47727269,13.31035 L14.5227272,13.31035 L14.5227272,18.1379362 L3.47727269,18.1379362 L3.47727269,13.31035 Z"
              id="Atom-/-Icon-/-Printer-"
            />
          </g>
        </g>
      </g>
    </g>
  </>,
  "Printer",
  { viewBox: "0 0 18 15", titleAccess: "Printer" }
);
